import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import {
  KEYSTROKE,
  MiscellaneousUtils,
  PREVENT_KEYUP_EVENTS,
  SEARCH_QUITE_PERIOD
} from '../../../../shared/utils/miscellaneous.utils';
import { SortUtils } from '../../../../shared/utils/sort.utils';
import { AuthService } from '../../../security/service/auth.service';
import { UserModel } from '../../../user/model/user.model';
import { UsersService } from '../../../user/service/users.service';
import { SPUserListColumnsModel } from '../../model/sp-user-list-columns.model';
import { SPUserModel } from '../../model/sp-user.model';

@Component({
  selector: 'sp-user',
  templateUrl:
    './console/app-js/modules/spUser/components/spUser/sp-user.component.html'
})
export class SPUserComponent extends APIOperableComponent implements OnInit {
  public static SERVICEPROVIDERADD = 'Add User';
  public static SERVICEPROVIDEREDIT = 'Edit User';
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  columns = SPUserListColumnsModel;
  public serviceProvidersFiltered = [];
  protected serviceProvidersList: Array<any> = [];
  protected originalSPsData: Array<any> = [];
  public selectedServiceProvider: any;
  public openUserModal = false;
  public userModalTitle: string;
  public user: UserModel;
  public serviceProviders: any;
  public editUserData: any;
  public showResetPasswordModal: Boolean = false;
  public isEmailSent: Boolean = false;
  public resetPasswordUrl: string;
  public isUrlGenerated: Boolean = false;
  public isUrlCopied: Boolean = false;
  private infiniteScroll: Boolean = false;
  private originalData: Array<SPUserModel>;
  data: Array<SPUserModel> = [];
  public noRecordsSettings = {
    message: '',
    styleClass: 'no-records-wrapper'
  };
  filterValue = '';
  private typingTimeout: any;
  private endCursor: string = null;
  private hasNextPage: Boolean = false;
  private filterSearch: Boolean = true;
  private originalUserData: Array<SPUserModel>;
  private pageNumber: number = 1;
  private pageSize: number = 100;
  private searchQuery: string = '';

  protected originalSPsDataAll: Array<any> = [];
  public serviceProvidersFilteredAll = [];
  protected serviceProvidersListAll: Array<any> = [];
  public serviceProvidersAll: any;

  private isLoadProvidersAll: boolean = false;

  ngOnInit() {
    this.loadServiceProvidersWithPaging();
  }

  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private usersService: UsersService
  ) {
    super(progressService, toastr, authService);
  }
  onReset(): void {
    this.data = this.originalUserData;
    this.setDefaultNoRecordSettings();
    this.endCursor = null;
    this.hasNextPage = false;
  }

  loadServiceProvidersWithPaging() {
    this.usersService
      .getServiceProvidersWithPaging(
        this.pageNumber,
        this.pageSize,
        this.searchQuery
      )
      .subscribe(result => {
        this.originalSPsData = SortUtils.sortCollection(
          MiscellaneousUtils.safeAccess(result, 'results'),
          'number'
        ).slice();
        this.serviceProvidersFiltered = [...this.originalSPsData];
        this.serviceProvidersList = [...this.originalSPsData];

        this.serviceProviders = result.results.map(e => {
          return { text: e.number };
        });
        this.serviceProvidersAll = this.serviceProviders;
        this.isLoadProvidersAll =
          this.serviceProvidersAll.length > 0 ? true : false;
      });
  }

  loadUserData() {
    if (!this.selectedServiceProvider) {
      this.data = [];
      this.setDefaultNoRecordSettings();
      this.noRecordsSettings.message = 'No Results Found';
      this.noRecordsSettings.styleClass = null;
      return;
    }

    this.loadingIndicator = true;
    this.data = [];
    this.usersService
      .getSPUsers(this.filterValue, this.selectedServiceProvider)
      .subscribe(
        result => {
          this.originalUserData = result.users;
          let dataCheck = JSON.parse(JSON.stringify(this.data));
          if (dataCheck !== null && this.infiniteScroll) {
            dataCheck.push(...this.originalUserData);
            this.data = [...dataCheck];
            this.infiniteScroll = false;
          } else if (this.filterSearch === true) {
            this.data = [...this.originalUserData];
            this.filterSearch = false;
          }
          if (this.originalUserData.length === 0) {
            this.data = [];
            this.setDefaultNoRecordSettings();
            this.noRecordsSettings.message = 'No Results Found';
            this.noRecordsSettings.styleClass = null;
          }
          this.loadingIndicator = false;
          this.endCursor = result.endCursor;
          this.hasNextPage = result.hasNextPage;
          setTimeout(() => {
            this.searchInput.nativeElement.focus();
          }, 100);
        },
        error => {
          console.error(error);
          this.loadingIndicator = false;
          this.data = [];
        }
      );
  }

  /**
   * Infinity scrolling pagination functionality
   */
  infinityScroll(): void {
    if (this.hasNextPage) {
      this.infiniteScroll = true;
      this.onSearch();
    }
  }

  onSearch(): void {
    if (!this.filterValue || this.filterValue.length < 3) {
      this.onReset();
      if(!this.selectedServiceProvider) {
        this.data = [];
      }
      if(this.selectedServiceProvider) {
        this.onSearchSPNumber()
      }
      return;
    }

    this.data = [];
    this.loadingIndicator = true;
    this.setDefaultNoRecordSettings();
    this.usersService
      .getSPUsers(this.filterValue, this.selectedServiceProvider)
      .subscribe(
        result => {
          this.originalData = result.users;
          let dataCheck = JSON.parse(JSON.stringify(this.data));
          if (dataCheck !== null && this.infiniteScroll) {
            dataCheck.push(...this.originalData);
            this.data = [...dataCheck];
            this.infiniteScroll = false;
          } else if (this.filterSearch === true) {
            this.data = [...this.originalData];
            this.filterSearch = false;
          }
          if (this.originalData.length === 0) {
            this.noRecordsSettings.message = 'No Results Found';
            this.noRecordsSettings.styleClass = null;
          }
          this.loadingIndicator = false;
          this.endCursor = result.endCursor;
          this.hasNextPage = result.hasNextPage;
          setTimeout(() => {
            this.searchInput.nativeElement.focus();
          }, 100);
        },
        error => {
          console.error(error);
          this.loadingIndicator = false;
          this.data = [];
        }
      );
  }
  /**
   * Set No Records Settings to Default state.
   */
  private setDefaultNoRecordSettings(): void {
    this.noRecordsSettings = {
      message: '',
      styleClass: 'no-records-wrapper'
    };
  }
  public onserviceProviderValueChange(item: any) {
    if (item) {
      this.selectedServiceProvider = item['number'];
      this.infiniteScroll = true;
      this.loadUserData();
    } else {
      this.selectedServiceProvider = null;
      this.data = [];
    }
  }

  public onserviceProviderFilterChange(value: any) {
    this.serviceProvidersFiltered = this.serviceProvidersList.filter(
      result => result.number.toLowerCase().indexOf(value.toLowerCase()) > -1
    );
  }

  onFilterData($event): void {
    this.filterSearch = true;
    this.endCursor = null;
    if ($event.code === KEYSTROKE.ENTER) {
      this.onSearch();
    } else if (!PREVENT_KEYUP_EVENTS.test($event.code)) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = setTimeout(
        () => this.onSearch(),
        SEARCH_QUITE_PERIOD
      );
    }
  }

  onSearchSPNumber(): void {
    let inputTextFilterValue = '';
    if (this.filterValue && this.filterValue.length >= 3) {
      inputTextFilterValue = this.filterValue;
      } 

    this.data = [];
    if(this.selectedServiceProvider) {
      this.loadingIndicator = true;
      this.usersService
      .getSPUsers(inputTextFilterValue, this.selectedServiceProvider)
      .subscribe(
        result => {
          this.originalUserData = result.users;
          let dataCheck = JSON.parse(JSON.stringify(this.data));
          if (dataCheck !== null) {
            this.infiniteScroll = false;
            this.data = [...this.originalUserData];
          }
          if (this.originalUserData.length === 0) {
            this.noRecordsSettings.message = 'No Results Found';
            this.noRecordsSettings.styleClass = null;
          }
          this.loadingIndicator = false;
        },
        error => {
          console.error(error);
          this.loadingIndicator = false;
          this.data = [];
        }
      );
    } else if(this.filterValue  && this.filterValue.length >= 3){
      this.filterSearch = true;
      this.onSearch()
      }

  }
  /**
   * Open the Edit User groups modal.
   * @param user
   */
  onAddUser(event: any): void {
    if (event && event.columnIndex === 5) {
      this.showResetPasswordModal = true;
      this.user = event.dataItem;
    } else {
      this.userModalTitle = SPUserComponent.SERVICEPROVIDERADD;
      this.user = new UserModel();
      if (event) {
        this.userModalTitle = SPUserComponent.SERVICEPROVIDEREDIT;
        this.user = event.dataItem;
        this.user.isEdit = true;
      }
      this.openUserModal = true;
    }
  }

  public closedUserModal(event) {
    this.openUserModal = false;
    this.showResetPasswordModal = false;
    if (event && event.isActionPerformed) {
      this.infiniteScroll = true;
      this.loadUserData();
      setTimeout(() => {
        const keypress = new KeyboardEvent('keypress', {
          key: 'Enter',
          code: 'Enter'
        });
      }, 300);
    }
  }
  /**
   * Close and cancel password reset modal
   */
  public close() {
    this.showResetPasswordModal = false;
    this.openUserModal = false;
  }
}
